import { Button, FormControl, FormControlLabel, FormLabel, Grid, InputLabel, Radio, RadioGroup, Select } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import SharedTitle from '../../Components/SharedForms/SharedTitle';
import { getServiciosMed, getServicioAutSanitaria, postServicioAutSanitaria, deleteSerivioAutSanitaria } from 'services/api';
import Spinner from '@jumbo/components/custom/Spinner';
import CapacidadInstalada2 from '../../Components/SharedForms/CapacidadInstalada2';
import { formatRut, LABEL_INPUT_FONT_SIZE, ordenarArregloAlfabeticamente, validateRut, tiposAux } from '../../ConstsAndUtils/utils';
import AsInstalacionFuncionamiento from '../../Components/FormCapacidadInstaladaComponents/AsInstalacionFuncionamiento';
import { CustomToast, toast } from '@jumbo/components/custom/Toast';
import AppTextInput from '@jumbo/components/Common/formElements/AppTextInput';
import { Save } from '@material-ui/icons';
import CapacidadInstaladaContentBody from '../../Components/SharedForms/CapacidadInstaladaContentBody';

const SalaDeProcedimientoMovil = (props) => {


    const [isLoading, setIsLoading] = useState(true)
    const [instalacionesList, setInstalacionesList] = useState([])
    const [titulo, setTitulo] = useState('Cargando...')
    const [descripcion, setDescripcion] = useState('')

    const [hasService, setHasService] = useState(0)
    const [aut_sanitaria, set_aut_sanitaria] = useState(0)
    const [nro_resolucion, set_nro_resolucion] = useState('')
    const [fecha_resolucion, set_fecha_resolucion] = useState('')
    const [tipo_servicio, set_tipo_servicio] = useState(0)
    const [nombre_proveedor, set_nombre_proveedor] = useState('')
    const [rut_proveedor, set_rut_proveedor] = useState('')
    const [guardar_flag, set_guardarFlag] = useState(true)
    const [flag_mostrar, set_flag_mostrar] = useState(false)

    const [flag_cambios_guardados, set_flag_cambios_guardados] = useState(false)
    const [open, setOpen] = useState(true);

    useEffect(() => {
        const baseValid = (
            aut_sanitaria !== 0 &&
            nro_resolucion !== '' &&
            fecha_resolucion !== '' &&
            tipo_servicio !== 0
        );

        const extraValid = (
            rut_proveedor !== '' &&
            nombre_proveedor !== ''
        );

        const isValid = tipo_servicio !== 2
            ? baseValid
            : baseValid && extraValid && validateRut(rut_proveedor);

        set_guardarFlag(!isValid);
    }, [
        aut_sanitaria,
        nro_resolucion,
        fecha_resolucion,
        tipo_servicio,
        rut_proveedor,
        nombre_proveedor
    ]);

    useEffect(() => {
        if (flag_mostrar) {
            setIsLoading(true)
            getServiciosMed(sessionStorage.getItem('idNav'))
                .then(res => {
                    setTitulo(res.data.nombre)
                    if (res.data.descripcion) {
                        setDescripcion(res.data.descripcion)
                    }
                    setInstalacionesList(ordenarArregloAlfabeticamente(res.data.espacios) || [])
                })
                .catch(e => console.error(e))
                .finally(f => {
                    setIsLoading(false)
                })
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [flag_mostrar])

    useEffect(() => {
        resetData()
        setIsLoading(true)
        const user = JSON.parse(sessionStorage.getItem("user"))

        getServiciosMed(sessionStorage.getItem('idNav'))
            .then(res => {
                setTitulo(res.data.nombre)
                if (res.data.descripcion) {
                    setDescripcion(res.data.descripcion)
                }

            })
            .catch(e => console.error(e))
            .finally(f => {
                getServicioAutSanitaria(user.organization.id, sessionStorage.getItem('idNav'))
                    .then(res => {
                        if (res.data.length === 0) {

                        } else {
                            set_aut_sanitaria(res.data.id_autoridad ? res.data.id_autoridad : 0)
                            set_nro_resolucion(res.data.nro_resolucion ? res.data.nro_resolucion : '')
                            set_fecha_resolucion(res.data.fecha_resolucion ? res.data.fecha_resolucion : '')
                            set_tipo_servicio(res.data.tipo_servicio ? parseInt(res.data.tipo_servicio) : 0)
                            set_rut_proveedor(res.data.rut_proveedor_servicio ? res.data.rut_proveedor_servicio : '')
                            set_nombre_proveedor(res.data.nombre_proveedor_servicio ? res.data.nombre_proveedor_servicio : '')
                            setHasService(res.data.otorga_servicio ? res.data.otorga_servicio : 0)
                            set_flag_mostrar(true)
                        }
                    })
                    .catch(e => console.error(e))
                    .finally(f => setIsLoading(false))
            })


        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    const resetData = () => {
        set_aut_sanitaria(0)
        set_nro_resolucion('')
        set_fecha_resolucion('')
        set_tipo_servicio(0)
        set_rut_proveedor('')
        set_nombre_proveedor('')
        setHasService(0)
        set_flag_mostrar(false)
    }

    const enviarDataAutsanitaria = () => {
        const user = JSON.parse(sessionStorage.getItem("user"))
        setIsLoading(true)
        let data = {
            otorga_servicio: 1,
            id_prestador: user.organization.id,
            id_ficha_tecnica: sessionStorage.getItem('idFicha'),
            nro_resolucion: nro_resolucion,
            id_autoridad: aut_sanitaria,
            rut_proveedor_servicio: rut_proveedor ? rut_proveedor : null,
            id_servicio_medico: sessionStorage.getItem('idNav'),
            fecha_resolucion: fecha_resolucion ? fecha_resolucion : null,
            nombre_proveedor_servicio: nombre_proveedor ? nombre_proveedor : null,
            tipo_servicio: tipo_servicio
        }
        postServicioAutSanitaria(data)
            .then(res => {

                setOpen(false)
                set_flag_cambios_guardados(true)
                toast.success("Datos de autorización sanitaria guardados con éxito")
            })
            .catch(e => console.error())
            .finally(f => {
                set_flag_mostrar(true)
            })
    }

    const deleteServicio = () => {
        const user = JSON.parse(sessionStorage.getItem("user"))
        deleteSerivioAutSanitaria(user.organization.id, sessionStorage.getItem('idNav'))
            .then(res => {
                set_aut_sanitaria(0)
                set_nro_resolucion('')
                set_fecha_resolucion('')
                set_tipo_servicio(0)
                set_rut_proveedor('')
                set_nombre_proveedor('')
                setHasService(0)
                set_flag_mostrar(false)
            })
            .catch(e => console.error(e))
            .finally(f => {

            })
    }


    const campos = [

        { id: 'nombre', label: 'Nombre', type: 'name', shown: true },
        { id: 'id_tipo_servicio', label: 'Tipo de servicio', type: 'select', shown: true },
        { id: 'id_edo_aut_sanitaria', label: 'Autorización sanitaria', type: 'select', shown: true },
        { id: 'nro_resolucion', label: 'Número resolución', type: 'number', shown: true },
        { id: 'fecha_resolucion', label: 'Fecha resolución', type: 'date', shown: false },
        { id: 'id_autoridad', label: 'Autoridad que otorga', type: 'select', shown: false },
        { id: 'cantidad', label: 'Cantidad', type: 'number', shown: true },
        { id: 'ubicacion', label: 'Ubicación', type: 'text', shown: true },

    ]

    return (
        <>
            {isLoading ?
                <Spinner show={isLoading} />
                :
                null
            }
            <>
                <CapacidadInstaladaContentBody
                    titulo={titulo}
                    descripcion={descripcion}
                    hasService={hasService}
                    setHasService={setHasService}
                    guardar_flag={guardar_flag}
                    flag_cambios_guardados={flag_cambios_guardados}
                    deleteServicio={deleteServicio}
                    setOpen={setOpen}
                    open={open}
                    nro_resolucion={nro_resolucion}
                    fecha_resolucion={fecha_resolucion}
                    aut_sanitaria={aut_sanitaria}
                    set_nro_resolucion={set_nro_resolucion}
                    set_fecha_resolucion={set_fecha_resolucion}
                    set_aut_sanitaria={set_aut_sanitaria}
                    tipo_servicio={tipo_servicio}
                    set_tipo_servicio={set_tipo_servicio}
                    nombre_proveedor={nombre_proveedor}
                    set_nombre_proveedor={set_nombre_proveedor}
                    rut_proveedor={rut_proveedor}
                    set_rut_proveedor={set_rut_proveedor}
                    flag_mostrar={flag_mostrar}
                    enviarDataAutsanitaria={enviarDataAutsanitaria}
                    instalacionesList={instalacionesList}
                    hasCount={false}
                    campos={campos}
                    setIsLoading={setIsLoading}
                    tiposAux={tiposAux}

                />

            </>
            <CustomToast />
        </>
    )

}

export default SalaDeProcedimientoMovil